import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  OnInit,
  signal,
  ViewChild
} from '@angular/core';
import { AuthService } from '../../auth/auth.service';
import {ActivatedRoute, Router} from '@angular/router';
import {CachingService} from '../../services/caching.service';
import {Subject, take, takeUntil} from 'rxjs';
import {ModalButton} from '../../common-components/modal/modal.component';
import {FormControl} from '@angular/forms';
import {UserService} from '../../services/user.service';
import {MatIconButton} from '@angular/material/button';
import {TranslocoService} from '@ngneat/transloco';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class HomeComponent implements OnInit, AfterViewInit, OnDestroy {

  showDeleteConfirmation = signal(false);
  deleteAllQuests = new FormControl(false);


  modalButtons: ModalButton[] = [];

  @ViewChild('menuButtonTrigger') menuButtonTrigger: MatIconButton;

  private destroy$ = new Subject<void>();

  constructor(private authService: AuthService,
              private router: Router,
              private cachingService: CachingService,
              private activatedRoute: ActivatedRoute,
              private transloco: TranslocoService,
              private userService: UserService) {
    // this.activatedRoute.fragment.pipe(takeUntil(this.destroy$)).subscribe((fragment) => {
    //   console.log('here', fragment);
    // });
    console.log('home constructor');
  }

  ngOnInit(): void {
    console.log('home init');


    this.modalButtons = [
      {
        type: 'secondary',
        text: this.transloco.translate('stay'),
        onClick: () => (this.showDeleteConfirmation.set(false))
      },
      {
        type: 'error',
        text: this.transloco.translate('delete'),
        onClick: () => this.deleteUser()
      }
    ];

    this.cachingService.clearChainEditCache();
  }

  ngAfterViewInit(): void {
    // this.activatedRoute.fragment.pipe(takeUntil(this.destroy$)).subscribe((fragment) => {
    //   if (fragment === 'user-modal') {
    //     this.menuButtonTrigger._elementRef.nativeElement.click();
    //     this.router.navigate([], {fragment: null});
    //   }
    // });
  }

  logout(): void {
    this.authService.logout();
    this.router.navigate(['/auth/login']);
  }

  private deleteUser(): void {
    this.userService.deleteUser$(this.deleteAllQuests.value).subscribe(() => {
      this.showDeleteConfirmation.set(false);
      this.logout();
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
